export default {"src":"/_next/static/media/ico_star.a805461e.svg","height":23,"width":24,"blurWidth":0,"blurHeight":0};